import { Card, CardBody, Spinner } from "reactstrap";
import ReactPlayer from "react-player";
import { useState, useEffect } from "react";

//local imports
import classes from "@/styles/quick-videos/quick-videos-main.module.css";
import { quickVideos } from "@/utils/content";
import data from "@/data/quick-videos.json";

type Props = {
  showTitle?: boolean;
};

export default function QuickVideosMain({ showTitle }: Props) {
  const content = quickVideos.en;

  const [getStarted, setGetstarted] = useState<any>({});
  const [tutorials, setTutorials] = useState<any>({});
  const [otherVideos, setOtherVideos] = useState<any>({});

  useEffect(() => {
    setGetstarted(data.gettingStarted);
    setTutorials(data.tutorials);
    setOtherVideos(data.otherVideos);
  }, []);

  return (
    <div className={classes.container}>
      {showTitle && (
        <section className={classes.hero}>
          <h1>{content.title}</h1>
        </section>
      )}
      <section className="my-5 container">
        <Card>
          <CardBody className={classes.cardWrapper}>
            {!getStarted ? (
              <Spinner
                className="m-auto"
                animation="border"
                role="status"
              ></Spinner>
            ) : (
              <div>
                <h5>{getStarted.label}</h5>
                <div className={classes.horizontalScroll}>
                  {getStarted.videos?.map((v: any, i: number) => {
                    return (
                      <Card className={classes.card} key={i}>
                        <CardBody>
                          <ReactPlayer url={v.url} height={150} width={265} />
                          <p>{v.title}</p>
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
              </div>
            )}
            <br />
            {!tutorials ? (
              <Spinner
                className="m-auto"
                animation="border"
                role="status"
              ></Spinner>
            ) : (
              <div>
                <h5>{tutorials.label}</h5>
                <div className={classes.horizontalScroll}>
                  {tutorials.videos?.map((v: any, i: number) => {
                    return (
                      <Card className={classes.card} key={i}>
                        <CardBody>
                          <ReactPlayer url={v.url} height={150} width={265} />
                          <p>{v.title}</p>
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
              </div>
            )}
            <br />
            {!otherVideos ? (
              <Spinner
                className="m-auto"
                animation="border"
                role="status"
              ></Spinner>
            ) : (
              <div>
                <h5>{otherVideos.label}</h5>
                <div className={classes.horizontalScroll}>
                  {otherVideos.videos?.map((v: any, i: number) => {
                    return (
                      <Card className={classes.card} key={i}>
                        <CardBody>
                          <ReactPlayer url={v.url} height={150} width={265} />
                          <p>{v.title}</p>
                        </CardBody>
                      </Card>
                    );
                  })}
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      </section>
    </div>
  );
}
